<template>
    <div class="content">
        
        <div v-if="audio" class="content__audio">
            <audio-player
                :src="audio">
            </audio-player>
            <h1 class="content__audio__heading">{{ title }}</h1>
        </div>
        <diary v-else-if="id == '297'">
        </diary>  
        <div v-else v-bind:class="cssHeaderClass()">
            <h1 class="content__header__heading">{{ title }}</h1>
        </div>

        <blocks
            :slug="slug" 
            :blocks="blocks">
        </blocks>
        <div v-if="ageGroups && ageGroups.length" class="content__age">
            <label class="content__age__label">
                Aldersgruppe:
            </label>
            <div
                v-for="(ageGroup, index) in ageGroups"
                v-bind:key="index" v-html="ageGroup.title"
                class="content__age__group">
            </div>
        </div>
        <div v-if="artist" class="content__artist"
             v-html="artist">
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import AudioPlayer from '@/components/AudioPlayer';
    import Diary from '@/components/Diary';
    import Blocks from '@/components/Blocks';

    export default {
        name: 'Home',
        components: {
            AudioPlayer,
            Diary,
            Blocks
        },
        computed: mapState([
            'ready',
            'pages',
            'slug'
        ]),
        data: function () {
            return {
                id:null,
                title: null,
                audio: null,
                ageGroups: null,
                artist: null,
                color: null,
                blocks: [],

                cachedPages: []
            }
        },

        created() {
            const slug = this.$route.params.slug || '';
            this.getPage(slug);
        },
        beforeRouteUpdate (to, from, next) {
            const slug = to.params.slug || '';
            this.getPage(slug);
            next();
        },
        methods: {
            ...mapActions([
                'loadPage',
                'setColor']),
            cssHeaderClass() {
                let classes = { 'content__header' : true };
                if(this.color) {
                    classes['bg-color'] = true;
                    classes['bg-color-' + this.color] = true;
                }
                return classes;
            },
            async getPage(slug) {      
                try {

                    await this.loadPage(slug);
                    if(typeof this.pages[slug] != "undefined") {

                        const page = this.pages[slug];

                        this.id = page.id;
                        this.title = page.title;
                        this.audio = page.audio && page.audio.length ? page.audio[0].url : null;

                        this.ageGroups = page.ageGroups;
                        this.artist = page.artist;
                        this.color = page.color;
                        this.blocks = page.blocks;

                        this.setColor(page.color);
                    }
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    };
</script>

<style lang="scss">
    .content {

        &__header {
            width:100%;
            &__heading {
                padding:50px 0 20px 0;
                text-align: center;
                font-size: 26px;
            }

            &.bg-color {
                .content__header__heading {
                    padding:22px 0 !important;
                    color:#000 !important;
                }
            }
        }

        &__age {
            display: flex;
            flex-grow: 1;
            align-items: flex-end;
            padding:0 10px 10px 10px;

            &__label {
                margin-right: 5px;
                font-weight: bold;
            }

            &__group + &__group {
                &::before {
                    content: ", ";
                }
            }

        }
    
        &__artist {
            padding:0 10px 10px 10px;
            font-size:14px;
        }

        &__audio {
            width: 100%;
            max-width: 960px;
            padding:50px 25px 30px 25px;
            text-align: center;

            &__heading {
                margin-top:30px;
            }
        }

    }
</style>